import { buildProps, definePropType } from '@sgui-plus/utils/props'
import { mutable } from '@sgui-plus/utils/types'
import type { TabPaneContext } from './constants'
import type { ExtractPropTypes } from 'vue'

export const tabBar = buildProps({
  tabs: {
    type: definePropType<TabPaneContext[]>(Array),
    default: () => mutable([] as const),
  },
} as const)

export type TabBar = ExtractPropTypes<typeof tabBar>
